import { render } from "./AdditionDetailsPage.vue?vue&type=template&id=2e013ee4&scoped=true"
import script from "./AdditionDetailsPage.vue?vue&type=script&lang=js"
export * from "./AdditionDetailsPage.vue?vue&type=script&lang=js"

import "./AdditionDetailsPage.vue?vue&type=style&index=0&id=2e013ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e013ee4"]])

export default __exports__